'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; /**
                                   * Created by Administrator on 2016/7/3.
                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require('redux-form');

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _SubmitBtn = require('../SubmitBtn/SubmitBtn');

var _SubmitBtn2 = _interopRequireDefault(_SubmitBtn);

var _reactCollapse = require('react-collapse');

var _reactCollapse2 = _interopRequireDefault(_reactCollapse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PackagingModal = (_dec = (0, _reduxForm.reduxForm)({
  form: 'productDetailPackaging',
  fields: ['packaging']
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PackagingModal, _Component);

  function PackagingModal() {
    (0, _classCallCheck3.default)(this, PackagingModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(PackagingModal).call(this));

    _this.state = {
      packagingItem: '',
      isOpened: true,
      closeHover: false
    };
    return _this;
  }

  (0, _createClass3.default)(PackagingModal, [{
    key: 'onExpandTextClick',
    value: function onExpandTextClick() {
      this.setState({
        isOpened: !this.state.isOpened
      });
    }
  }, {
    key: 'onPackagingChosened',
    value: function onPackagingChosened(packaging, packagingItem) {
      if (packaging.value === packagingItem) {
        packaging.onChange('');
      } else {
        packaging.onChange(packagingItem);
      }
    }
  }, {
    key: 'analysisPackagingData',
    value: function analysisPackagingData() {
      var _this2 = this;

      var _props = this.props;
      var packaging = _props.fields.packaging;
      var packagingData = _props.packagingData;

      var styles = require('./PackagingModal.scss');
      // const {packagingItem} = this.state;
      var isOpened = this.state.isOpened;

      var groupInfo = [];
      if (packagingData instanceof Array) {
        packagingData.forEach(function (singlePackaging) {
          var index = groupInfo.findIndex(function (info) {
            return info.groupId === singlePackaging.groupId;
          });
          if (index < 0) {
            groupInfo.push({
              groupId: singlePackaging.groupId,
              groupName: singlePackaging.groupName,
              items: [{
                id: singlePackaging.id,
                name: singlePackaging.name,
                describe: singlePackaging.describe,
                price: singlePackaging.price,
                img: singlePackaging.img
              }]
            });
          } else {
            groupInfo[index].items.push({
              id: singlePackaging.id,
              name: singlePackaging.name,
              describe: singlePackaging.describe,
              price: singlePackaging.price,
              img: singlePackaging.img
            });
          }
        });
      }
      return groupInfo.map(function (info) {
        return _react2.default.createElement(
          'div',
          { key: info.groupId },
          _react2.default.createElement(
            'div',
            { className: styles.header },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              info.groupName
            )
          ),
          _react2.default.createElement('div', { className: 'clear' }),
          _react2.default.createElement(
            _reactCollapse2.default,
            { isOpened: isOpened },
            _react2.default.createElement(
              'ul',
              null,
              info.items instanceof Array ? info.items.map(function (child) {
                return _react2.default.createElement(
                  'li',
                  { key: info.groupId + ',' + child.id },
                  _react2.default.createElement(
                    'div',
                    { style: { position: 'relative' } },
                    _react2.default.createElement('img', {
                      style: { width: '159px', height: '159px' },
                      onClick: function onClick() {
                        return _this2.onPackagingChosened(packaging, info.groupId + ',' + child.id);
                      }, src: child.img }),
                    packaging.value === info.groupId + ',' + child.id ? _react2.default.createElement('span', { className: styles.spana }) : ''
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.divDe, style: { marginLeft: '20px' } },
                    child.name + ' : '
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.divDe },
                    child.price
                  ),
                  _react2.default.createElement('div', { className: 'clear' })
                );
              }) : ''
            )
          ),
          _react2.default.createElement('div', { className: 'clear' })
        );
      });
    }
  }, {
    key: 'closeImgMouseOver',
    value: function closeImgMouseOver() {
      this.setState({
        closeHover: true
      });
    }
  }, {
    key: 'closeImgMouseLeave',
    value: function closeImgMouseLeave() {
      this.setState({
        closeHover: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./PackagingModal.scss');
      var _props2 = this.props;
      var handleSubmit = _props2.handleSubmit;
      var onClose = _props2.onClose;
      var isOpened = _props2.isOpened;

      var customStyle = {
        content: {
          background: '#ffffff',
          overflow: 'hidden',
          outline: 'none',
          zIndex: 9999,
          border: '0',
          borderRadius: '30px',
          boxShadow: '3px 2px 20px',
          bottom: 'auto',
          minHeight: '10rem',
          left: '50%',
          padding: '2rem 0px',
          position: 'fixed',
          right: 'auto',
          top: '50%',
          transform: 'translate(-50%,-50%)',
          minWidth: '20rem',
          width: '80rem',
          maxWidth: '80rem'
        }
      };
      var closeHover = this.state.closeHover;

      var hoverClassName = styles.zhuan_a;
      if (closeHover) {
        hoverClassName = styles.zhuan;
      }
      return _react2.default.createElement(
        _reactModal2.default,
        { style: customStyle, isOpen: isOpened },
        _react2.default.createElement(
          'div',
          { className: styles.close },
          _react2.default.createElement('img', { className: hoverClassName, onMouseOver: this.closeImgMouseOver.bind(this),
            onMouseLeave: this.closeImgMouseLeave.bind(this), onClick: function onClick() {
              return onClose();
            },
            src: 'http://tupian.goeasy.cn:9999/yipinwang/third/close.png', alt: '',
            width: '100%' })
        ),
        _react2.default.createElement(
          'form',
          { className: styles.component },
          _react2.default.createElement(
            'div',
            { className: styles.modalContent },
            this.analysisPackagingData()
          ),
          _react2.default.createElement('div', { className: 'clear' }),
          _react2.default.createElement(_SubmitBtn2.default, { btnClick: handleSubmit, text: '确定' }),
          _react2.default.createElement(_SubmitBtn2.default, { btnClick: onClose, text: '关闭' }),
          _react2.default.createElement('div', { className: 'clear' })
        )
      );
    }
  }]);
  return PackagingModal;
}(_react.Component), _class2.propTypes = {
  active: _react.PropTypes.string,
  asyncValidating: _react.PropTypes.bool.isRequired,
  fields: _react.PropTypes.object.isRequired,
  dirty: _react.PropTypes.bool.isRequired,
  resetForm: _react.PropTypes.func.isRequired,
  invalid: _react.PropTypes.bool.isRequired,
  pristine: _react.PropTypes.bool.isRequired,
  valid: _react.PropTypes.bool.isRequired,
  handleSubmit: _react.PropTypes.func,

  isOpened: _react.PropTypes.bool,
  packagingData: _react.PropTypes.array,
  onClose: _react.PropTypes.func,
  onSubmit: _react.PropTypes.func
}, _temp)) || _class);
exports.default = PackagingModal;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/PackagingModal/PackagingModal.js
 ** module id = 1387
 ** module chunks = 0
 **/